import { buildURL, buildObjectFromURL } from './url';

function findParentCategories(categories = {}, categoryId) {
    const tree = [];

    if (!categoryId) {
        return tree;
    }

    tree.push(Object.assign({}, categories[categoryId]));

    let parent = Object.values(categories).find(category => {
        if (category.sub_categories) {
            if (category.sub_categories.includes(categoryId)) {
                return category.sub_categories.includes(categoryId);
            }

            const parentCategory = category.sub_categories.find(category => {
                return category.id === categoryId;
            });

            if (parentCategory) {
                return parentCategory;
            }

            return false;
        }

        return false;
    });

    while (parent) {
        tree.push(Object.assign({}, parent));
        parent = Object.values(categories).find(category => {
            if (category.sub_categories) {
                return category.sub_categories.includes(parent.id);
            }

            return false;
        });
    }

    return tree;
}

function getCategoryHeirarchy(flatCategoryMap, categoryId, location, config = { get: () => { } }) {
    const heirarchy = [];
    const useFakeLevelSlug = config.get('SEO', 'useFakeLevelSlug');
    const categoryCover = config.get('categoryCover');
    const seoFriendlyBreadcrumb = config.get('seoFriendlyBreadcrumb');
    const noindexListingCategories = config.get('SEO', 'noindexListingCategories');
    const isOlxMobbi = config.get('isOlxMobbi');

    while (categoryId) {
        const category = flatCategoryMap[categoryId];
        const isNoIndexCategory = noindexListingCategories
            && noindexListingCategories.length > 0
            && noindexListingCategories.indexOf(categoryId) >= 0;

        if (!category || isNoIndexCategory) {
            break;
        }

        const text = (seoFriendlyBreadcrumb && category.parent_id) ? {
            translation: {
                id: 'usedCategory',
                values: {
                    category: category.name
                }
            }
        } : {
            text: category.name
        };

        heirarchy.unshift({
            ...text,
            href: buildURL({
                category,
                location
            }, { useFakeLevelSlug, categoryCover }, !!isOlxMobbi)
        });

        categoryId = !(seoFriendlyBreadcrumb && seoFriendlyBreadcrumb.hideCategoryL1) && category.parent_id;
    }

    return heirarchy;
}

const getIsCategoryDeprecated = (categoryId, deprecatedCategoryIds = []) => !!(categoryId && Array.isArray(deprecatedCategoryIds) && deprecatedCategoryIds.some(dc => Number(dc) === Number(categoryId)));

const getUrlObj = pathname => buildObjectFromURL(pathname);

export {
    getCategoryHeirarchy,
    getIsCategoryDeprecated,
    findParentCategories,
    getUrlObj
};
